export default [
    // monthly installment table data
    {
        customer_expenses:[
            {
                kyc_data_id: 1,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "Housing",
                frequency_id: 2,
                frequency_name: 'Monthly',
                customer_question_id: "",
                customer_question_column: "Water/Electricity Bill",
                customer_value: 50.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:0,
                admin_annual_value:0,
                remark: '',
            },
            {
                kyc_data_id: 2,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 2,
                customer_sub_category_name: "Transportation",
                frequency_id: 2,
                frequency_name: 'Monthly',
                customer_question_id: "",
                customer_question_column: "Car Fuel",
                customer_value: 600.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:0,
                admin_annual_value:0,                
                remark: '',
            },
            {
                kyc_data_id: 3,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "Housing",
                frequency_id: 2,
                frequency_name: 'Monthly',
                customer_question_id: "",
                customer_question_column: "Rental",
                customer_value: 600.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:0,
                admin_annual_value:0,                
                remark: '',
            },
            {
                kyc_data_id: 4,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "Foods",
                frequency_id: 2,
                frequency_name: 'Monthly',
                customer_question_id: "",
                customer_question_column: "Groceries expenses",
                customer_value: 1000.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:800,
                admin_annual_value:0,                
                remark: '',
            },
            {
                kyc_data_id: 5,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "Household And Entertainment",
                frequency_id: 2,
                frequency_name: 'Monthly',
                customer_question_id: "",
                customer_question_column: "Relief for parents",
                customer_value: 250.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:0,
                admin_annual_value:0,                
                remark: '',
            },
            {
                kyc_data_id: 6,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "One Time Expenses",
                frequency_id: 1,
                frequency_name: 'Annually',
                customer_question_id: "",
                customer_question_column: "Festival celebration expenses",
                customer_value: 1200.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 0,
                admin_month_value:0,
                admin_annual_value:0,                
                remark: '',
            },
            {
                kyc_data_id: 7,
                kyc_customer_id: 16,
                external_customer_id: 3075,
                customer_form_id: 1,
                customer_category_id: 1,
                customer_category_name: "Expenses",
                customer_sub_category_id: 1,
                customer_sub_category_name: "Transportation",
                frequency_id: 1,
                frequency_name: 'Annually',
                customer_question_id: "",
                customer_question_column: "Car Maintenance",
                customer_value: 2400.00,
                customer_month_value:50.00,
                customer_annual_value:50.00 * 12,
                admin_value: 1000,
                admin_month_value:200,
                admin_annual_value:2400,                
                remark: '',
            },
        ],
        total_month: 350.00,
        total: 350.00 * 12
    }
]